// Navigation helpers for the conundrums flow.
import { navigate } from "src/utils/reactRouterNavigate";

export function navigateToConundrumsList(mountPoint: string, classId: string) {
  navigate(`/apps/remote/${mountPoint}/${classId}/conundrums`);
}

export function navigateToConundrumStep(mountPoint: string, classId: string, conundrumName: string, stepIndex: number) {
  navigate(`/apps/remote/${mountPoint}/${classId}/conundrums/${conundrumName}/${stepIndex}`);
}

export function navigateToConundrumsFeedback(mountPoint: string, classId: string) {
  navigate(`/apps/remote/${mountPoint}/${classId}/conundrums/feedback`);
}

export function navigateToLaunchpad(mountPoint: string, classId: string) {
  navigate(`/apps/remote/${mountPoint}/${classId}`);
}
